export default "__VITE_ASSET__Cay9Sxun__"